import * as angular from 'angular';

export class BillingAccountsRequests {

  /* @ngInject */
  constructor(private $billingAccounts, private BillingAccountsAPI, private splitService) {
  }

  getAccountsById(billingAccountId) {
    // TODO The API URL is incorrect and needs to be changed
    const api = this.BillingAccountsAPI.actions.getAccountsById;
    return this.$$call(api, {}, {}, {id: billingAccountId});
  }

  getProcessor(billingAccountId) {
    const api = this.BillingAccountsAPI.actions.getProcessor;
    return this.$$call(api, {}, {}, {}, billingAccountId);
  }

  addPaymentMethod(billingAccountId, token) {
    const api = this.BillingAccountsAPI.actions.addPaymentMethod;
    return this.$$call(api, {}, {}, {token: token}, billingAccountId);
  }

  removePaymentMethod(billingAccountId, pmToken) {
    const api = this.BillingAccountsAPI.actions.removePaymentMethod;
    return this.$$call(api, {}, {}, {pmToken: pmToken}, billingAccountId);
  }

  getProcessorToken(billingAccountId) {
    const api = this.BillingAccountsAPI.actions.getProcessorToken;
    return this.$$call(api, {}, {}, {}, billingAccountId);
  }

  getBillingAccount(billingAccountId, sync?) {
    const api = this.BillingAccountsAPI.actions.getBillingAccount;
    return this.$$call(api, {sync: sync}, {}, {}, billingAccountId);
  }

  addRefund(transaction, payload) {
    const api = this.BillingAccountsAPI.actions.refund;
    return this.$$call(api, {}, payload, {transactionId: transaction.tid}, transaction.billingAccountId)
  }

  getTransactions(billingAccountId, query) {
    const api = this.BillingAccountsAPI.actions.getTransactions;
    return this.$$call(api, query, {}, {}, billingAccountId)
  }

  charge(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.charge;
    return this.$$call(api, {}, payload, {}, billingAccountId)
  }

  addCredit(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.addCredit;
    return this.$$call(api, {}, payload, {}, billingAccountId)
  }

  addDebit(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.addDebit;
    return this.$$call(api, {}, payload, {}, billingAccountId)
  }

  createInvoice(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.createInvoice;
    return this.$$call(api, {}, payload, {}, billingAccountId)
  }

  createReceipt(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.createReceipt;
    return this.$$call(api, {}, payload, {}, billingAccountId)
  }

  createInverc(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.createInverc;
    return this.$$call(api, {}, payload, {}, billingAccountId)
  }

  createDeal(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.createDeal;
    return this.$$call(api, {}, payload, {}, billingAccountId)
  }

  exportTransactions(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.export;
    return this.$$call(api, {
      from: payload.from,
      to: payload.to,
      zoneId: this.splitService.getTimeZone()
    }, {}, {}, billingAccountId)
  }

  getPreferences(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.getPreferences;
    return this.$$call(api, {}, payload, {billingAccountId: billingAccountId})
  }

  update(billingAccountId, billingAccount) {
    const api = this.BillingAccountsAPI.actions.update;
    return this.$$call(api, {}, billingAccount, {billingAccountId: billingAccountId})
  }

  updatePreferences(billingAccountId, payload) {
    const api = this.BillingAccountsAPI.actions.updatePreferences;
    return this.$$call(api, {}, payload, {billingAccountId: billingAccountId})
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options, billingAccountId?) {
    return this.$billingAccounts(billingAccountId).$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingAccountsRequests', BillingAccountsRequests);
